import { render, staticRenderFns } from "./info_base.vue?vue&type=template&id=12650471&scoped=true"
import script from "./info_base.vue?vue&type=script&lang=js"
export * from "./info_base.vue?vue&type=script&lang=js"
import style0 from "./info_base.vue?vue&type=style&index=0&id=12650471&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12650471",
  null
  
)

export default component.exports